/**
 * Common
 */
const axios = require("axios");
const graphQLEndpoint = "https://checkout.callia.com/api/2024-10/graphql.json";
// TODO: replace with env value
const accessToken = "7704488aef4e017ab481754b92acd59f";

/**
 * Product Type
 */
const SIGNATURE_COLLECTION = "Signature";
const LUXE_COLLECTION = "Luxe";
const STANDARD_SIZE = "Standard";
const DELUXE_SIZE = "Deluxe";
const GRAND_SIZE = "Grand";
const VASE = "Vase";
const GIFT_ADDS = "Gift-adds";
const BUNDLE = "Bundle";
const GREET_NAME = "Send a Greet";
const CURATED = "Curated_Bundle";
const CARD = "Card";
const DELIVERY = "Delivery";
const BOUQUET = "Flowers";
const SUBSCRIPTION_3MONTH = "Subscription-3";
const SUBSCRIPTION_6MONTH = "Subscription-6";
const SUBSCRIPTION_CUSTOM = "Subscription";
const SUBSCRIPTION_ONGOING = "Subscription-Ongoing";
const SUBSCRIPTION = "Subscription";
const SUBSCRIPTION_MDAY = "mothers-day-subscription";
const SUBSCRIPTION_TYPES = [
  SUBSCRIPTION_3MONTH,
  SUBSCRIPTION_6MONTH,
  SUBSCRIPTION_CUSTOM,
  SUBSCRIPTION_ONGOING,
  SUBSCRIPTION_MDAY
]
const BOUQUET_TYPES = [
  BOUQUET,
  BUNDLE,
  SUBSCRIPTION_3MONTH,
  SUBSCRIPTION_6MONTH,
  CURATED,
  SUBSCRIPTION_MDAY
];
const GIFT_CARD = "Gift-Card";
const GREET = "Greet";
const BOUQUET_SIZE_TAGS = [
  {bouquet_size_tag: "50% Larger"},
  {bouquet_size_tag: "2X Larger"},
  {bouquet_size_tag: "2X Larger | Best value!"},
];
const BOLD_RECURRING_ORDER =
  "https://recurringcheckout.com/s/callia-flowers/checkout/recurring_product?shop_url=callia-flowers.myshopify.com";
const SUBS_UPGRADE = "sub-upgrade";
const SUBS_TAGS = ["Basic", "Signature", "Luxe"];

/**
 * Query
 */
const itemFilterWithActive = (tag: string, productType: string) => {
  const ITEM_FILTER_WITH_ACTIVE = `query {
    products (
      first: 35,
      query: "tag:${tag} AND tag:active AND product_type:${productType} AND available_for_sale:true"
    ) {
      edges {
        node {
          id
          description
          availableForSale
          title
          tags
          handle
          images(first: 10) {
            edges {
              node {
                id
                originalSrc
              }
            }
          }
          priceRange {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          variants(first: 10) {
            edges {
              node {
                id
                availableForSale
                sku
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPriceV2 {
                  amount
                  currencyCode
                }
                product {
                  description
                  title
                  productType
                  id
                }
              }
            }
          }
          sellingPlanGroups(first: 1) {
            edges {
              node {
                name
                sellingPlans(first: 10) {
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`;

  return ITEM_FILTER_WITH_ACTIVE;
};

const ongoingCardsQuery = (tag: string, productType: string) => {
  return `query {
    products (
      first: 25,
      query: "tag:${tag} AND tag:active AND tag:card-ongoing AND product_type:${productType} AND available_for_sale:true AND NOT tag:exclusive-card"
    ) {
      edges {
        node {
          id
          description
          availableForSale
          title
          tags
          handle
          images(first: 10) {
            edges {
              node {
                id
                originalSrc
              }
            }
          }
          priceRange {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          variants(first: 10) {
            edges {
              node {
                id
                availableForSale
                sku
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPriceV2 {
                  amount
                  currencyCode
                }
                product {
                  description
                  title
                  productType
                  id
                }
              }
            }
          }
          sellingPlanGroups(first: 1) {
            edges {
              node {
                name
                sellingPlans(first: 10) {
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`;

};

const testSubsQuery = (tag: string, productType: string) => { //TODO: remove

  const ITEM_FILTER_WITH_ACTIVE = `query {
    products(first: 5, query: "tag:${tag}") {
      edges {
        node {
          id
          description
          availableForSale
          title
          tags
          handle
          images(first: 8) {
            edges {
              node {
                id
                originalSrc
              }
            }
          }
          priceRange {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          variants(first: 10) {
            edges {
              node {
                id
                availableForSale
                sku
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPriceV2 {
                  amount
                  currencyCode
                }
                product {
                  description
                  title
                  productType
                  id
                }
              }
            }
          }
          sellingPlanGroups(first: 1) {
            edges {
              node {
                name
                sellingPlans(first: 10) {
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  `;

  return ITEM_FILTER_WITH_ACTIVE;
};


const itemfilterWithCharity = (region: string, productType: string) => {
  const ITEM_FILTER_WITH_CHARITY = `query {
    products (first: 25, query:"tag:${region} AND product_type:${productType} AND tag:charity AND available_for_sale:true" ) {
      edges {  node {
          id description availableForSale title tags handle
          images(first:10){ edges{ node{ id originalSrc } } }
          priceRange{ maxVariantPrice{ amount currencyCode } minVariantPrice{amount currencyCode } }
          variants(first:10){ edges{ node{ id availableForSale sku priceV2 { amount currencyCode } product{description title productType id}  }} }
      } }
    } }`;
  return ITEM_FILTER_WITH_CHARITY;
};

const itemFilterWithGreets = () => {
  const VIDEO_MESSAGE_ITEM_FILTER = `query { products (first: 30, query:"sku:greet AND tag:greet AND tag:gift-adds" ) {
    edges {  node {  id description availableForSale title tags handle images(first:10){ edges{ node{ id originalSrc } } }
     priceRange{ maxVariantPrice{ amount currencyCode } minVariantPrice{amount currencyCode } }
     variants(first:10){ edges{ node{ id availableForSale sku compareAtPriceV2 {amount currencyCode} priceV2{amount } product{description title productType id}  }} }
    } } } }`;

  return VIDEO_MESSAGE_ITEM_FILTER;
};

const itemFilterWithProdUpgrades = () => {
  const UPGRADE_ITEM_FILTER = `query { products (first: 30, query:"tag:gift-adds AND tag:Upgrade AND tag:vase" ) {
    edges {  node {  id description availableForSale title tags handle images(first:10){ edges{ node{ id originalSrc } } }
     priceRange{ maxVariantPrice{ amount currencyCode } minVariantPrice{amount currencyCode } }
     variants(first:10){ edges{ node{ id availableForSale sku compareAtPriceV2 {amount currencyCode} priceV2{amount } product{description title productType id}  }} }
    } } } }`;

  return UPGRADE_ITEM_FILTER;
};

const filterProductByHandle = (sku: string) => {
  const FILTER_PRODUCT_BY_HANDLE = `{
    product(handle: "${sku}") {
      id
      title
      tags
      handle
      productType
      variants(first: 60) {
        edges {
          node {
            id
            availableForSale
            quantityAvailable
            compareAtPriceV2 {
              amount
              currencyCode
            }
            title
            sku
            priceV2 {
              amount
              currencyCode
            }
            image {
              id
              originalSrc
              transformedSrc
            }
            product {
              description
              title
              productType
              id
            }
          }
        }
      }
      images(first: 10) {
        edges {
          node {
            id
            originalSrc
            transformedSrc
          }
        }
      }
      sellingPlanGroups(first: 5) {
        edges {
          node {
            name
            sellingPlans(first: 10) {
              edges {
                node {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
  `;

  return FILTER_PRODUCT_BY_HANDLE;
};

const filterProductDetails = (id: string) => {
  const FILTER_PRODUCT_DETAILS = `{ node(id:"${id}"){
    ... on Product {
    id title tags handle productType
    variants(first:45){ edges{ node{ id quantityAvailable availableForSale title sku priceV2 { amount currencyCode } compareAtPriceV2 {amount currencyCode} product{title productType id}}}}
    }}}`;

  return FILTER_PRODUCT_DETAILS;
};

const getDeliveryProductByHandle = (deliveryProductType: string) => {
  const DELIVERY_CHARGE = `query {  products (first: 3, query:"product_type:${deliveryProductType}" ) {
    edges {  node {    id description availableForSale title tags productType handle
    images(first:5){ edges{ node{  id originalSrc } } }
    priceRange{ maxVariantPrice{ amount currencyCode }
      minVariantPrice{amount currencyCode } }
  variants(first:100){ edges{ node{          id availableForSale sku priceV2{amount } product{description title productType id} }} }
 } }  } }`;
  return DELIVERY_CHARGE;
};

const getProductsWithProductType = (productType: string, tag: string) => {
  const PRODUCTS_FILTER_WITH_PRODUCT_TYPE = `query {
      products (first: 20, query:"tag:${tag} AND product_type:${productType} AND available_for_sale:true" ) {
      edges {  node {
      id availableForSale title tags
      priceRange{ maxVariantPrice{ amount currencyCode } minVariantPrice{amount currencyCode } }
      variants(first:10){ edges{ node{ title sku compareAtPriceV2 {amount currencyCode} priceV2 { amount currencyCode } availableForSale
      product{title productType id} }} }
      } }
  } }`;

  return PRODUCTS_FILTER_WITH_PRODUCT_TYPE;
};

const getSubscriptionsWithTag = (
  productType: string,
  mainTag: string,
  subTag: string
) => {
  const SUBSCRIPTION_FILTER_WITH_TAGS = `query {
    products (first: 20, query:"tag:${mainTag} AND tag:${subTag} product_type:${productType} AND available_for_sale:true" ) {
    edges {  node {
    id availableForSale title tags
    priceRange{ maxVariantPrice{ amount currencyCode } minVariantPrice{amount currencyCode } }
    variants(first:10){ edges{ node{ title sku compareAtPriceV2 {amount currencyCode} priceV2 { amount currencyCode } availableForSale
    product{title productType id} }} }
    } }
    } }`;

  return SUBSCRIPTION_FILTER_WITH_TAGS;
};

const FilterWithProductTypeOnly = (country: string, productType: string) => {
  const PRODUCTS_FILTER_WITHPRODUCT_TYPE_ONLY = `query {
    products (first: 20, query:"tag:${country} AND product_type:${productType} AND available_for_sale:true" ) {
      edges {  node {
          id availableForSale title tags
          priceRange{ maxVariantPrice{ amount currencyCode } minVariantPrice{amount currencyCode } }
          variants(first:10){ edges{ node{ title sku compareAtPriceV2 {amount currencyCode} priceV2 { amount currencyCode } availableForSale
          product{title productType id} }} }
      } }
    } }`;
  return PRODUCTS_FILTER_WITHPRODUCT_TYPE_ONLY;
};

const FilterBouquetsLandingProducts = (dateCode: string, productType: string) => {
  const BOUQUET_LANDING_PRODUCTS_FILTER = `query {
    products (first: 20, query:"tag:LANDING AND tag:${dateCode} AND product_type:${productType} AND available_for_sale:true") {
            edges {  node {
      id handle availableForSale title tags
      priceRange{ maxVariantPrice{ amount currencyCode } minVariantPrice{amount currencyCode } }
      variants(first:10){ edges{ node{ title sku compareAtPriceV2 {amount currencyCode} priceV2 { amount currencyCode } availableForSale
      product{title productType id} }} }
      } }
          } }`;
  return BOUQUET_LANDING_PRODUCTS_FILTER;
};
const FilterBundleLandingProducts = (dateCode: string, productType: string) => {
  const BUNDLE_LANDING_PRODUCTS_FILTER = `query {
          products (first: 10, query:"tag:LANDING AND tag:${dateCode} AND product_type:${productType}" ) {
           edges {  node {
      id handle availableForSale title tags
      priceRange{ maxVariantPrice{ amount currencyCode } minVariantPrice{amount currencyCode } }
      variants(first:10){ edges{ node{ title sku compareAtPriceV2 {amount currencyCode} priceV2 { amount currencyCode } availableForSale
      product{title productType id} }} }
      } }
          } }`;
  return BUNDLE_LANDING_PRODUCTS_FILTER;
};

// set common query for landing and other catorized products
const FilterProductByCategory = (dateCode: string, tag: string, region: string, landing: boolean = false) => {
  let tagCombination = tag;
  (landing) ? tagCombination = tagCombination + " AND tag:LANDING" : tagCombination + " ";
  (region !== "") ? tagCombination = tagCombination + ` AND tag:${region}` : "";
  (tag.includes("6 Month Subscription")) ? dateCode = "" : dateCode = `tag:${dateCode}`

  const CATEGORIZED_FILTER_PRODUCTS = `query {
    products (first: 20, query:"${tagCombination} AND ${dateCode} AND available_for_sale:true") {
            edges {  node {
      id handle availableForSale title tags
      priceRange{ maxVariantPrice{ amount currencyCode } minVariantPrice{amount currencyCode } }
      variants(first:10){ edges{ node{ title sku compareAtPriceV2 {amount currencyCode} priceV2 { amount currencyCode } availableForSale
      product{title productType id} }} }
      } }
          } }`;
  return CATEGORIZED_FILTER_PRODUCTS;
};

const FilterLandingProducts = (dateCode: string, query: string) => {
  const LANDING_PRODUCTS_FILTER = `query {
    products (first: 20, query:"${query} tag:LANDING AND tag:${dateCode} AND available_for_sale:true") {
            edges {  node {
      id handle availableForSale title tags
      priceRange{ maxVariantPrice{ amount currencyCode } minVariantPrice{amount currencyCode } }
      variants(first:10){ edges{ node{ title sku compareAtPriceV2 {amount currencyCode} priceV2 { amount currencyCode } availableForSale
      product{title productType id} }} }
      } }
          } }`;
  return LANDING_PRODUCTS_FILTER;
};

// set common query for landing and other categorized products
const FilterProductBySpecificTags = (tag: string, landing: boolean = false) => {
  let tagCombination = tag;
  (landing) ? tagCombination = tagCombination + " AND tag:LANDING" : tagCombination + " ";

  const SPECIFIC_TAGS_FILTER_PRODUCTS = `query {
    products (first: 20, query:"${tagCombination} AND available_for_sale:true") {
            edges {  node {
      id handle availableForSale title tags
      priceRange{ maxVariantPrice{ amount currencyCode } minVariantPrice{amount currencyCode } }
      variants(first:10){ edges{ node{ title sku compareAtPriceV2 {amount currencyCode} priceV2 { amount currencyCode } availableForSale
      product{title productType id} }} }
      } }
          } }`;
  return SPECIFIC_TAGS_FILTER_PRODUCTS;
};


/**
 * GraphQL executor
 */
const invokeShopifyQuery = async (request: string) => {
  const {data} = await axios
    .post(graphQLEndpoint, request, {
      headers: {
        "X-Shopify-Storefront-Access-Token": accessToken,
        Accept: "application/json",
        "Content-Type": "application/graphql",
      },
    })
    .catch(function (error: any) {
      console.error(error);
    });
  return data;
};

const invokeShopifyCheckoutCreate = async (
  lineItemsRequest: any,
  currencyCode: string,
) => {
  let request = JSON.stringify({
    query: `mutation cartCreateMutation($cartInput: CartInput) {
      cartCreate(input: $cartInput) {
        cart {
          id
          checkoutUrl
        }
          userErrors {
          field
          message
        }
      }
    }`,
    variables: lineItemsRequest
  });

  const {data} = await axios
    .post(graphQLEndpoint, request, {
      headers: {
        "X-Shopify-Storefront-Access-Token": accessToken,
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    })
    .catch(function (error: any) {
      console.error(error);
    });
  return data;
};

const invokeShopifyCartCreate = async (lineItems: any, currencyCode: string) => {
  const mutation = `
    mutation cartCreate($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          id
          checkoutUrl
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const requestBody = JSON.stringify({
    query: mutation,
    variables: {input: lineItems.cartInput}
    ,
  });

  const {data} = await axios.post(graphQLEndpoint, requestBody, {
    headers: {
      'X-Shopify-Storefront-Access-Token': accessToken,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  }).catch(function (error: any) {
    console.error(error);
  });
  return data;

};

export {
  testSubsQuery,
  invokeShopifyQuery,
  invokeShopifyCheckoutCreate,
  itemFilterWithActive,
  itemFilterWithGreets,
  itemFilterWithProdUpgrades,
  filterProductByHandle,
  ongoingCardsQuery,
  filterProductDetails,
  getDeliveryProductByHandle,
  getProductsWithProductType,
  getSubscriptionsWithTag,
  FilterWithProductTypeOnly,
  itemfilterWithCharity,
  FilterBouquetsLandingProducts,
  FilterBundleLandingProducts,
  FilterProductByCategory,
  FilterLandingProducts,
  FilterProductBySpecificTags,
  invokeShopifyCartCreate,
  VASE,
  GREET_NAME,
  GIFT_ADDS,
  BUNDLE,
  CURATED,
  CARD,
  DELIVERY,
  BOUQUET,
  SUBSCRIPTION,
  SUBSCRIPTION_3MONTH,
  SUBSCRIPTION_6MONTH,
  SUBSCRIPTION_CUSTOM,
  SUBSCRIPTION_ONGOING,
  SUBSCRIPTION_TYPES,
  BOUQUET_TYPES,
  GIFT_CARD,
  GREET,
  BOUQUET_SIZE_TAGS,
  BOLD_RECURRING_ORDER,
  SUBS_UPGRADE,
  SUBS_TAGS,
  SIGNATURE_COLLECTION,
  LUXE_COLLECTION,
  STANDARD_SIZE,
  DELUXE_SIZE,
  GRAND_SIZE,
};
